import React, { useEffect, useState, useRef,useCallback } from 'react';
import Column from './Column.js';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { AddColumnCall, columnIndex, getAllColumns } from '../Redux/slice.js';
import services from '../services/index.js';
import { columnsLocal } from '../utils/LocalSt.js';
import email from '../api/email.js';
import { GET_ALL_USER } from '../utils/Apifunction.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import AddColumnModal from './AddBoard/AddColumnModal.js';
import TableData from './Table/TableData.js';
import DatePlan from './Date/DatePlan.js';
import { debounce } from 'lodash';
import { getAllDateTableTask } from '../Redux/GetSlice.js';
import { useTaskData } from '../hooks/useTaskData.js';

function ColumnContainer({
    handleAddColumn,
    columnAddStatus,
    setColumnAddStatus,
    getTaskMailIndbox,
    filterList,
    selectedBoardId,
    moveColumn,
    taskMail,
    setTaskMail,
    getTaskMail,
    removeTask,
    setSortBy,
    setSortOrder,
    sortby,
    getAllBoard,
    sortOrder,
    activeButton,
    moveTask,
    isArchivedBoard,
}) {
    const [statusUpdate, setStatusUpdate] = useState(true);
    const [taskDetailsPopup, setTaskDetailsPopup] = useState(false);
    const [taskAssign, setTaskAssign] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [isShiftPressed, setIsShiftPressed] = useState(false);
    const { columns, isTableVisible, isDateVisible } = useSelector(
        (state) => ({
            columns: state.redux.columns,
            isTableVisible: state.redux.isTableVisible,
            isDateVisible: state.redux.isDateVisible,
        }),
        (prev, next) =>
            prev.columns === next.columns &&
            prev.isTableVisible === next.isTableVisible &&
            prev.isDateVisible === next.isDateVisible,
    );
    const dispatch = useDispatch();
    const [conData, setConData] = useState(columnsLocal());
    const [selectedMyDayPlanDate, setSelectedMyDayPlanDate] = useState({
        myDayPlan: null,
        deadline: null,
        isAll: 'both',
    });
    const [selectedReminderDate, setSelectedReminderDate] = useState(null);
    const [selectedStatusNextStepDate, setSelectedStatusNextStepDate] = useState(null);
    const [notesText, setNotesText] = useState('');
    const [myDayDate, setMyDayDate] = useState(null);
    const [deadlineDate, setDeadlineDate] = useState(null);

    const [isMyDayChecked, setIsMyDayChecked] = useState(true);
    const [isDeadlineChecked, setIsDeadlineChecked] = useState(true);
    const [taskLimit, setTaskLimit] = useState(10);
    const [hasMoreTasks, setHasMoreTasks] = useState(true);
    const isLoadingMoreRef = useRef(false);
    // const handleDateSelect = (type, daysOffset, taskItem) => {
    //     let updateType = type;

    //     if (type === 'myday') {
    //         if (isMyDayChecked) {
    //             setMyDayDate(daysOffset);
    //             if (isDeadlineChecked) {
    //                 setDeadlineDate(daysOffset);
    //                 updateType = 'both'; // both should be updated
    //             } else {
    //                 setDeadlineDate(deadlineDate); // keep existing
    //             }
    //         } else {
    //             setMyDayDate(daysOffset); // only myDay update
    //         }
    //     } else if (type === 'deadline') {
    //         if (isDeadlineChecked) {
    //             setDeadlineDate(daysOffset);
    //             if (isMyDayChecked) {
    //                 setMyDayDate(daysOffset);
    //                 updateType = 'both';
    //             } else {
    //                 setMyDayDate(myDayDate); // keep existing
    //             }
    //         } else {
    //             setDeadlineDate(daysOffset);
    //         }
    //     }

    //     // Call update task function with calculated info
    //     handleUpdateTask(daysOffset, updateType, taskItem);

    //     // Reset checkboxes
    //     setTimeout(() => {
    //         setIsMyDayChecked(true);
    //         setIsDeadlineChecked(true);
    //     }, 100);
    // };

    const [note, setNote] = useState('');
    // const getTaskMail = async () => {
    //     const query = {
    //         limit: 400,
    //     };
    //     const obj = new URLSearchParams(query);
    //     try {
    //         const response = await services.task.GET_TASK(obj);
    //         if (response) {
    //             let data = JSON.parse(JSON.stringify(response?.data?.data));
    //             setTaskMail(data);
    //         }
    //     } catch (error) {
    //         console.error('Error fetching task emails:', error);
    //     }
    // };
    // const getTaskAssign = async () => {
    //     const response = await GET_ALL_USER({ limit: 10, email: searchTerm });
    //     response && setTaskAssign(response?.users);
    // };
    const getTaskAssign = async () => {
        const page = 1
        const falsePagination = false
        const response = await services.userassignboard.GET_ASSIGN_USER_BY_BOARD_ID(selectedBoardId, searchTerm, falsePagination, page);
        const allData = response?.data?.data || [];
        const uniqueUsers = Array.from(
            new Map(allData.map(item => [item.userId, item.User])).values()
        );
        response && setTaskAssign(uniqueUsers);
    };

    // useEffect(() => {
    //     getTaskMail();
    // }, []);

    useEffect(() => {
        getTaskAssign();
    }, [searchTerm, selectedBoardId]);

    // const columnMove = (draggedColumn, index) => {
    //     dispatch(columnIndex({ from: draggedColumn, to: index }));
    // };

    const debouncedSequenceUpdate = debounce((sequenceData) => {
        services.board
            .SEQUENCE(sequenceData, boardLocal()?.value)
            .catch((e) => console.error('Sequence update error:', e));
    }, 300);

    const columnMove = (fromIndex, toIndex) => {
        // Only dispatch to Redux for immediate UI update
        dispatch(columnIndex({ from: fromIndex, to: toIndex }));

        // Prepare but don't immediately execute sequence update
        const updatedColumns = [...columns];
        const [movedColumn] = updatedColumns.splice(fromIndex, 1);
        updatedColumns.splice(toIndex, 0, movedColumn);

        const sequenceData = updatedColumns.map((col, index) => ({
            id: col.id,
            sequence: index + 1,
        }));

        debouncedSequenceUpdate(sequenceData);
    };
    const moveChildTask = async (dragItem, dropItem, parentTaskStatus) => {
        const parentData = {
            parentTaskID: dropItem?.id || '',
            parentTaskStatus: !parentTaskStatus,
        };
        try {
            await services.task.UPDATE_CHILD_TASK(dragItem?.item?.id || dragItem?.id, parentData);
            getTaskMail();
        } catch (e) {
            console.error(e);
        }
    };



    const handleRemoveChild = (itemid, parentDataId, columnID, item) => {
        moveChildTask(item, '', true);
    };
    const {
        // State values

        // Action functions
        updateSelectedMyDayPlanDate,
        updateSelectedReminderDate,
        updateSelectedStatusNextStepDate,
        updateNote,
        updateNotesText,
        updateMyDayDate,
        updateDeadlineDate,
        updateIsMyDayChecked,
        updateIsDeadlineChecked,

        // Utility functions
        handleDateSelect,
        handleUpdateTask,
        resetAllTaskData,
    } = useTaskData();

    const [editTaskTitle, setEditTaskTitle] = useState();
    const [selectedTaskcolor, setSelectedTaskcolor] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [taskDeleteId, setTaskDeleteId] = useState('');
    const [openTaskId, setOpenTaskId] = useState(null);
    const columnRef = useRef(null);
    const toggleTaskDropdown = (id, item) => {
        setEditTaskTitle(item?.subject || item?.title);
        setSelectedTaskcolor(id);
        setTaskDeleteId(id);
        setIsOpen(!isOpen);
        setOpenTaskId((prevId) => (prevId === id ? null : id));
    };

    const [showBox, setShowBox] = useState(false);
    const [isSearchBoxOpen, setIsSearchBoxOpen] = useState(false);
    const [hoverIndex, setHoverIndex] = useState();

    const [colorIndexID, setColorIndexID] = useState();
    const [activePatch, setActivePatch] = useState(null);
    const [updateTitle, setUpdateTitle] = useState(false);
    const [isOpenDeadline, setIsOpenDeadline] = useState(false);

    const [taskToDelete, setTaskToDelete] = useState(null);

    const handleCancelDelete = () => {
        setTaskToDelete(null);
        setShowBox(false);
    };
    const handleEditTitle = () => {
        setUpdateTitle(true);
        setIsOpen(!isOpen);
        setIsOpenDeadline(false);
    };

    const clearHighlight = () => {
        handleTaskSelectedColor('');
    };

    const handleClick = () => {
        setIsOpen(false);
    };
    const handleTaskSelectedColor = async (selectedColor) => {
        const data = {
            color: selectedColor,
        };
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/task/updateTask/${selectedTaskcolor}`,
                data,
            );
            getTaskMail();
            setIsSearchBoxOpen(false);
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const deleteTaskMail = async () => {
        try {
            const response = await services.task.DELETE_TASK(taskDeleteId || taskToDelete);
            if (response) {
                getTaskMail();
                const data = {
                    boardId: selectedBoardId,
                };
                dispatch(getAllDateTableTask({ data }));
                setShowBox(false);
            }
        } catch (error) {
            console.error('Error fetching task emails:', error);
        }
    };

    const loadMoreTasks = useCallback(() => {
        if (isLoadingMoreRef.current || !hasMoreTasks) return;
        isLoadingMoreRef.current = true;
        const nextLimit = taskLimit + 10;
        getTaskMail(nextLimit, { append: true })
            .then((res) => {
                const totalTasks = Number(res?.totalTasks) || 0;
                const dataObj = res?.data || {};
                const currentTotal = Object.keys(dataObj).reduce((sum, key) => {
                    const arr = dataObj[key];
                    return sum + (Array.isArray(arr) ? arr.length : 0);
                }, 0);

                setTaskLimit(nextLimit);
                if (currentTotal >= totalTasks) {
                    setHasMoreTasks(false);
                }
            })
            .finally(() => {
                isLoadingMoreRef.current = false;
            });
    }, [taskLimit, getTaskMail, hasMoreTasks, taskMail]);

    useEffect(() => {
        // Reset pagination when board changes or columns set changes
        setTaskLimit(10);
        setHasMoreTasks(true);
        isLoadingMoreRef.current = false;
    }, [selectedBoardId]);
    return (
        <div
            ref={columnRef}
            className="overflow-x-auto h-[93dvh] 2xl:h-[94dvh] 3xl:h-[93dvh]  min-h-[400px]"
            style={{
                overflowX: 'auto',
                whiteSpace: 'nowrap',
                overflowY: 'hidden',
                width: '100%',
                minWidth: '100%',
            }}
        // onWheel={(e) => {
        //     if (e.deltaY !== 0) {
        //         e.preventDefault();
        //         const container = e.currentTarget;
        //         container.scrollLeft += e.deltaY;
        //     }
        // }}
        >
            {/* {!isArchivedBoard && (
                <isArchivedBoard
                    columns={columns}
                    taskMail={taskMail}
                    isArchivedBoard={true} // A prop to differentiate from the main board
                    // The following props are passed to satisfy ColumnContainer's prop requirements.
                    // They can be connected to real logic later.
                    getTaskMail={() => {}}
                    setTaskMail={() => {}}
                    moveTask={() => {}}
                    setSortBy={() => {}}    
                    setSortOrder={() => {}}
                    getAllBoard={() => {}}
                />
            )} */}
            {isTableVisible === true ? (
                <TableData
                    columns={columns}
                    moveChildTask={moveChildTask}
                    taskMail={taskMail}
                    getTaskMailIndbox={getTaskMailIndbox}
                    getTaskMail={getTaskMail}
                    selectedBoardId={selectedBoardId}
                    setSortBy={setSortBy}
                    setSortOrder={setSortOrder}
                    sortby={sortby}
                    sortOrder={sortOrder}
                />
            ) : isDateVisible === true ? (
                <DatePlan
                    myDayDate={myDayDate}
                    setMyDayDate={setMyDayDate}
                    handleUpdateTask={handleUpdateTask}
                    selectedBoardId={selectedBoardId}
                    getTaskMail={getTaskMail}
                    deadlineDate={deadlineDate}
                    setDeadlineDate={setDeadlineDate}
                    handleDateSelect={handleDateSelect}
                    toggleTaskDropdown={toggleTaskDropdown}
                    isDateModal={isOpen}
                    showBox={showBox}
                    setShowBox={setShowBox}
                    setIsSearchBoxOpen={setIsSearchBoxOpen}
                    setHoverIndex={setHoverIndex}
                    setColorIndexID={setColorIndexID}
                    setActivePatch={setActivePatch}
                    hoverIndex={hoverIndex}
                    colorIndexID={colorIndexID}
                    activePatch={activePatch}
                    removeTask={removeTask}
                    handleEditTitle={handleEditTitle}
                    clearHighlight={clearHighlight}
                    handleClick={handleClick}
                    setUpdateTitle={setUpdateTitle}
                    updateTitle={updateTitle}
                    setIsOpenDeadline={setIsOpenDeadline}
                    isOpenDeadline={isOpenDeadline}
                    isSearchBoxOpen={isSearchBoxOpen}
                    handleTaskSelectedColor={handleTaskSelectedColor}
                    deleteTaskMail={deleteTaskMail}
                    taskToDelete={taskToDelete}
                    setTaskToDelete={setTaskToDelete}
                    handleCancelDelete={handleCancelDelete}
                />
            ) : (
                <div

                    style={{
                        display: 'flex',
                        gap: '1px',
                        minWidth: 'max-content',
                        height: '100%',
                    }}
                    className="column__container colum-border border-[2px] mt-[-8px]"
                >
                    {columns?.map((column, index) => (
                        <div   >

                            <Column

                                key={column?.id}
                                id={column?.id}
                                columnTitle={column?.title}
                                limit={column?.limit}
                                borderColor={column?.borderColor}
                                setStatusUpdate={setStatusUpdate}
                                statusUpdate={statusUpdate}
                                setTaskDetailsPopup={setTaskDetailsPopup}
                                taskDetailsPopup={taskDetailsPopup}
                                getTaskMail={getTaskMail}
                                taskMail={taskMail}
                                taskAssign={taskAssign}
                                setSearchTerm={setSearchTerm}
                                index={index}
                                columnMove={columnMove}
                                columnID={column?.id}
                                searchTerm={searchTerm}
                                isShiftPressed={isShiftPressed}
                                moveChildTask={moveChildTask}
                                handleRemoveChild={handleRemoveChild}
                                setIsShiftPressed={setIsShiftPressed}
                                setConData={setConData}
                                setColumnAddStatus={setColumnAddStatus}
                                selectedMyDayPlanDate={selectedMyDayPlanDate}
                                setSelectedMyDayPlanDate={setSelectedMyDayPlanDate}
                                selectedReminderDate={selectedReminderDate}
                                setSelectedReminderDate={setSelectedReminderDate}
                                selectedStatusNextStepDate={selectedStatusNextStepDate}
                                setSelectedStatusNextStepDate={setSelectedStatusNextStepDate}
                                note={note}
                                setNote={setNote}
                                handleDateSelect={handleDateSelect}
                                myDayDate={myDayDate}
                                deadlineDate={deadlineDate}
                                isMyDayChecked={isMyDayChecked}
                                isDeadlineChecked={isDeadlineChecked}
                                setIsMyDayChecked={setIsMyDayChecked}
                                setIsDeadlineChecked={setIsDeadlineChecked}
                                notesText={notesText}
                                setNotesText={setNotesText}
                                setMyDayDate={setMyDayDate}
                                setDeadlineDate={setDeadlineDate}
                                handleUpdateTask={handleUpdateTask}
                                columnDetails={columns}
                                selectedBoardId={selectedBoardId}
                                toggleTaskDropdown={toggleTaskDropdown}
                                editTaskTitle={editTaskTitle}
                                setEditTaskTitle={setEditTaskTitle}
                                selectedTaskcolor={selectedTaskcolor}
                                setSelectedTaskcolor={setSelectedTaskcolor}
                                isOpen={isOpen}
                                setIsOpen={setIsOpen}
                                taskDeleteId={taskDeleteId}
                                openTaskId={openTaskId}
                                showBox={showBox}
                                setShowBox={setShowBox}
                                setIsSearchBoxOpen={setIsSearchBoxOpen}
                                setHoverIndex={setHoverIndex}
                                setColorIndexID={setColorIndexID}
                                setActivePatch={setActivePatch}
                                hoverIndex={hoverIndex}
                                colorIndexID={colorIndexID}
                                activePatch={activePatch}
                                handleEditTitle={handleEditTitle}
                                clearHighlight={clearHighlight}
                                handleClick={handleClick}
                                setUpdateTitle={setUpdateTitle}
                                updateTitle={updateTitle}
                                setIsOpenDeadline={setIsOpenDeadline}
                                isOpenDeadline={isOpenDeadline}
                                isSearchBoxOpen={isSearchBoxOpen}
                                handleTaskSelectedColor={handleTaskSelectedColor}
                                deleteTask={deleteTaskMail}
                                taskToDelete={taskToDelete}
                                setTaskToDelete={setTaskToDelete}
                                handleCancelDelete={handleCancelDelete}
                                setTaskMail={setTaskMail}
                                getAllBoard={getAllBoard}
                                activeButton={activeButton}
                                onColumnScrollEnd={loadMoreTasks}
                            />
                        </div>
                    ))}
                    {selectedBoardId && (
                        <div className="" style={{ minWidth: '350px' }}>
                            <div className="task task-curve">
                                <button
                                    style={{ opacity: '0.3' }}
                                    className="add-task-button"
                                    onClick={() => {
                                        dispatch(AddColumnCall());
                                        setColumnAddStatus(true);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faPlus} />
                                </button>
                            </div>
                        </div>
                    )}

                    {columnAddStatus && (
                        <AddColumnModal
                            show={columnAddStatus}
                            onHide={() => setColumnAddStatus(false)}
                            handleAddColumn={handleAddColumn}
                        />
                    )}
                </div>
            )}

        </div>
    );
}

export default ColumnContainer;
